import seo from '@/seo/pages.json';
import seoLanguages from '@/seo/languages.json';

// First-touch attribution for sign-ups. Kept in sessionStorage (like the
// affiliate ref), so nothing outlives the tab, and sent only when an account
// is created.
const KEY = 'legacylens_first_touch';

const PUBLIC_PAGE_LANGUAGE = {
  ...Object.fromEntries(Object.entries(seo.pages).map(([route, p]) => [route, p.lang || 'en'])),
  ...Object.fromEntries(seoLanguages.languages.map((l) => [l.path, l.code])),
};

// Private routes carry tokens in the path (/shared/<token>, /gift/redeem/<code>),
// so anything that isn't a public page is reduced to its first segment.
function normalizePath(path) {
  if (path in PUBLIC_PAGE_LANGUAGE) return path;
  const segments = path.split('/').filter(Boolean);
  if (!segments.length) return '/';
  return segments.length > 1 ? `/${segments[0]}/*` : `/${segments[0]}`;
}

function referrerHost() {
  try {
    const host = new URL(document.referrer).hostname;
    return host && host !== window.location.hostname ? host : null;
  } catch {
    return null;
  }
}

export function captureFirstTouch() {
  try {
    if (sessionStorage.getItem(KEY)) return;
    const path = window.location.pathname.replace(/\/+$/, '') || '/';
    const params = new URLSearchParams(window.location.search);
    const touch = {
      landing_path: normalizePath(path),
      page_language: PUBLIC_PAGE_LANGUAGE[path] || null,
      referrer: referrerHost(),
      browser_language: (navigator.language || '').split('-')[0] || null,
      first_seen: new Date().toISOString().slice(0, 10),
    };
    for (const key of ['utm_source', 'utm_medium', 'utm_campaign']) {
      const value = params.get(key);
      if (value) touch[key] = value.slice(0, 64);
    }
    sessionStorage.setItem(KEY, JSON.stringify(touch));
  } catch {
    // Storage blocked (private mode, disabled site data): attribution is best effort.
  }
}

export function getSignupSource() {
  try {
    return JSON.parse(sessionStorage.getItem(KEY)) || null;
  } catch {
    return null;
  }
}
